import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/ProductListingConfiguration.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/configurations/listings`;
	}
	delete(e) {
		return this.api.delete(`${n.baseUrl}/${e}`);
	}
	listNames(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/names`, e));
	}
	associateFacetCollection(e, t) {
		return this.api.put(`${n.baseUrl}/${e}/facetCollection`, { facetCollectionConfigurationId: t });
	}
	disassociateFacetCollection(e) {
		return this.api.delete(`${n.baseUrl}/${e}/facetCollection`);
	}
};
//#endregion
export { n as ProductListingConfiguration };

//# sourceMappingURL=ProductListingConfiguration.js.map